<template>
    <div class="page">
        <div class="top-header">
            <div class="inputBox">
                <img
                    class="searchLogo"
                    src="~@/assets/search-logo.png"
                    alt=""
                />
                <form action="" onsubmit="return false">
                    <input
                        autocomplete="off"
                        type="search"
                        ref="input"
                        v-model="title"
                    />
                </form>
            </div>
            <span class="cancel" @click="goIndex()">取消</span>
        </div>
        <div class="box">
            <div class="zhuanqu">
                <div class="list">
                    <div
                        class="item"
                        v-for="item in list"
                        :key="item.id"
                        @click="goCourseDetail(item.id, item.classify)"
                    >
                        <div class="left">
                            <div
                                class="imgBox"
                                :style="{
                                    background:
                                        'url(' +
                                        item.adImg +
                                        ') no-repeat center/100% 100%',
                                }"
                            ></div>
                            <div class="activity-time-notice-box">
                                <img
                                    class="activity-time-notice"
                                    src="~@/assets/activity-time-notice.png"
                                    alt=""
                                />
                                <span class="notice">限时7天</span>
                            </div>
                        </div>
                        <div
                            class="right"
                            :class="[
                                item.classify == 'EPISODE' ? 'episoode' : '',
                            ]"
                        >
                            <div class="sub-title">{{ item.title }}</div>
                            <template v-if="item.classify == 'STUDY'">
                                <div class="desc" v-html="item.brief"></div>
                                <div
                                    class="leturerBox"
                                    v-if="item.trainerName.length > 0"
                                >
                                    <img
                                        class="leturer-logo"
                                        src="~@/assets/leturer-logo.png"
                                        alt=""
                                    />
                                    <span class="leturers">
                                        <span
                                            v-for="trainer in item.trainerName"
                                            :key="trainer"
                                        >
                                            {{ trainer }}
                                        </span>
                                    </span>
                                </div>
                                <div class="fenshiBox" v-if="item.studentNum">
                                    <img
                                        class="fenshi-logo"
                                        src="~@/assets/fenshi-logo.png"
                                        alt=""
                                    />
                                    <span class="num">
                                        {{ item.studentNum }}
                                    </span>
                                </div>
                                <div
                                    class="markBox"
                                    v-if="item.tagsName.length > 0"
                                >
                                    <span
                                        v-for="tag in item.tagsName"
                                        :key="tag"
                                        class="mark"
                                    >
                                        {{ tag }}
                                    </span>
                                </div>
                            </template>
                            <template v-if="item.classify == 'EPISODE'">
                                <div class="leturerBox sourceBox">
                                    <img
                                        class="leturer-logo"
                                        src="~@/assets/leturer-logo.png"
                                        alt=""
                                    />
                                    <span>{{ item.source }}</span>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import searchService from "../../service/search.service";
export default {
    name: "search",
    data() {
        return {
            list: [],
            title: "",
            couponId: "",
        };
    },
    mounted() {
        this.couponId = this.$route.query.couponId;
        if (this.couponId) {
            this.getList();
        }
        if (!this.couponId) {
            setTimeout(() => {
                this.$refs.input.focus();
            }, 500);
        }
        this.$refs.input.addEventListener("search", (e) => {
            e.preventDefault();
            this.getList();
        });
    },
    methods: {
        goIndex() {
            this.$router.push({ path: "/index" });
        },
        getList() {
            searchService
                .search({
                    title: this.title,
                    couponId: this.couponId,
                })
                .then((res) => {
                    this.list = res.data;
                });
        },
        goCourseDetail(id, type) {
            this.$router.push({ path: `/course-detail/${id}/${type}` });
        },
    },
};
</script>

<style lang="scss" scoped src="./search.scss">
</style>